
import { defineComponent } from 'vue'
import Chip from 'primevue/chip'
import Dialog from 'primevue/dialog'
import glossaryDefinitionDescriptor from '../GlossaryDefinitionDescriptor.json'
import glossaryDefinitionDialogDescriptor from './GlossaryDefinitionDialogDescriptor.json'

export default defineComponent({
    name: 'glossary-definition-info-dialog',
    components: { Chip, Dialog },
    emits: ['close'],
    props: {
        visible: { type: Boolean },
        contentInfo: { type: Object }
    },
    data() {
        return {
            glossaryDefinitionDescriptor,
            glossaryDefinitionDialogDescriptor
        }
    }
})
